export const members = [
  {
    id: "m1",
    name: "夜猫子小周",
    role: "资深吃瓜",
    joined: "加入 482 天",
    avatar: "周",
    quote:
      "以前吃瓜是东看一眼西看一眼，信息全在碎片里。现在每个话题都有一条清晰的时间线，能省下大量翻找的力气。",
    likes: 12480,
    comments: 2160,
  },
  {
    id: "m2",
    name: "理性吃瓜党",
    role: "观点输出",
    joined: "加入 361 天",
    avatar: "理",
    quote: "最喜欢的是评论区。同一个事情能看到完全相反的推理，而且大多讲得有条有理，比一个人想有意思多了。",
    likes: 9860,
    comments: 1740,
  },
  {
    id: "m3",
    name: "凌晨三点的键盘",
    role: "热聊常客",
    joined: "加入 274 天",
    avatar: "凌",
    quote: "热榜特别准。好几次我还没反应过来，榜单上已经挂着了，跟着点进去就能看到事情全貌，不用自己去拼。",
    likes: 8320,
    comments: 1520,
  },
  {
    id: "m4",
    name: "只看不吵",
    role: "观点输出",
    joined: "加入 519 天",
    avatar: "只",
    quote:
      "喜欢这里的氛围。吵归吵，但基本都对着事情本身。能看到有人认真写长评把逻辑讲通，而不是清一色的情绪输出。",
    likes: 15240,
    comments: 890,
  },
  {
    id: "m5",
    name: "追完就跑",
    role: "资深吃瓜",
    joined: "加入 198 天",
    avatar: "追",
    quote: "界面看着舒服，晚上刷不刺眼。评论发表之后立刻能看到，点赞也有反馈，整个体验很完整。",
    likes: 6740,
    comments: 1380,
  },
  {
    id: "m6",
    name: "工位潜水员",
    role: "围观群众",
    joined: "加入 421 天",
    avatar: "工",
    quote: "我大部分时间只潜水。但这里即使不发言也能看得很有收获，光是刷评论区的观点碰撞就够消磨一整晚。",
    likes: 5180,
    comments: 430,
  },
];

export const stats = [
  { label: "在聊话题", value: "770+", icon: "ri-chat-3-line" },
  { label: "累计观点", value: "31.6万", icon: "ri-quill-pen-line" },
  { label: "深夜活跃", value: "8.4万", icon: "ri-moon-clear-line" },
  { label: "平均讨论时长", value: "27分钟", icon: "ri-time-line" },
];